// import mergeDeep from '@/core/shared/helpers/mergeDeep'
import { state as initialState } from './state';
import deepmerge from 'deepmerge';
import * as Sentry from '@sentry/browser';

export const setPusherConfiguration = (state, pusherConfiguration) => {
  state.pusherConfiguration = pusherConfiguration;
};
export const resetLauncherState = state => {
  const s = initialState();
  Object.keys(s).forEach(key => {
    state[key] = s[key];
  });
};
export const setInitializedFlag = (state, isAppInitialized) => {
  state.isAppInitialized = isAppInitialized;
};
export const setGetStationIdentityFlag = (state, hasReceivedStationIdentity) => {
  state.hasReceivedStationIdentity = hasReceivedStationIdentity;
};
export const setRecoveringFlag = (state, isRecoveringFromSafetyMode) => {
  state.isRecoveringFromSafetyMode = isRecoveringFromSafetyMode;
};
export const setStationTags = (state, stationTagIds) => {
  state.stationTagIds = stationTagIds;
};
export const setLauncherStationTags = (state, stationTagIds) => {
  state.launcherstationTagIds = stationTagIds;
};
export const setFilteredGames = (state, gameIds) => {
  state.filteredGameIds = gameIds;
};
export const setSearchedGames = (state, gameIds) => {
  state.searchedGameIds = gameIds;
};
export const setLocale = (state, locale) => {
  state.locale = locale;
};
export const startLoading = (state, key) => {
  state.loadings[key] = true;
};
export const endLoading = (state, key) => {
  state.loadings[key] = false;
};
export const setError = (state, key) => {
  state.errors[key] = true;
};
export const resetError = (state, key) => {
  state.errors[key] = false;
};
export const enableFilters = state => {
  state.isFiltersEnabled = true;
};
export const disableFilters = state => {
  state.isFiltersEnabled = false;
};
export const setVolumeBeforeIdle = (state, volume) => {
  state.volumeBeforeIdle = volume;
};
export const enableSearch = state => {
  state.isSearchEnabled = true;
};
export const disableSearch = state => {
  state.isSearchEnabled = false;
};
export const setFilters = (state, filters) => {
  state.filters = filters;
};
export const setSearch = (state, search) => {
  state.search = search;
};
export const storePreviousRoute = (state, route) => {
  state.previousRoute = route;
};
export const registerPanel = (state, panel) => {
  const index = state.panels.findIndex(({ uid: _uid }) => _uid === panel.uid);
  const hasIndex = !~index;
  if (hasIndex) {
    state.panels.push(panel);
  } else {
    state.panels.splice(index, 1, panel);
  }
};
export const unregisterPanel = (state, uid) => {
  const index = state.panels.findIndex(({ uid: _uid }) => _uid === uid);
  state.panels.splice(index, 1);
};
export const setReviewingGameId = (state, id) => {
  state.reviewingGameId = id;
};
export const setBookingTimes = (state, bookingTimes) => {
  state.bookingTimes = bookingTimes;
};

// app state (from CEF)
export const setAppState = (state, payload) => {
  state.appState = {
    ...state.appState,
    ...payload,
  };
};
// session
export const setPreviousSession = (state, session) => {
  if (!session) {
    state.previousSession = null;
    return;
  }
  if (state.previousSession && state.previousSession.id === session.id) {
    state.previousSession = Object.freeze(deepmerge(state.previousSession, session));
    return;
  }
  if (session.startTime) {
    state.previousSession = Object.freeze(session);
  } else {
    Sentry.captureMessage('session skipped');
  }
};
export const setPreviousImpulseTime = (state, time) => {
  state.previousImpulseTime = time;
};
export const setSessionIdle = (state, idle) => {
  state.appState = {
    ...state.appState,
    idle,
  };
};
export const setSessionOverlay = (state, overlay) => {
  state.appState = {
    ...state.appState,
    overlay,
  };
};

export const registerPreviousBooking = (state, booking) => {
  state.previousBooking = booking;
};
export const setThemeParkGameId = (state, id) => {
  state.themeParkGameId = id;
};
export const setCurrentBookingTimeId = (state, id) => {
  state.currentBookingTimeId = id;
};
export const setDesktopClientVersion = (state, version) => {
  state.desktopClientVersion = version;
};
